export const DEPRECATED_STYLE_EXCLUSIVE_MARKER = 'deprecated-style-exclusive-marker';
